// src/views/C4S Decommission - Replacement/EditVehicleWTAMetadata.js
import { Breadcrumbs } from "@vds/breadcrumbs";
import React, { lazy } from "react";

export const EditVehicleWTAMetadata = {
  name: "Edit Vehicle WTA",
  id: "edit_vehicle_wta",
  component: lazy(() => import("../EditVehicleWTA/EditVehicleWTAComponent")),
  route: "/connect360/edit_vehicle_wta",
  Breadcrumbs: true,
};
